/**
* 店铺列表
**/ 

<template>
  <div class="w w1200 xy_min_height4">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="breakcrumbHeader"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>店铺</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 店铺列表 -->
    <el-row class="top25 store_bg store_min_h xy_radius4 box_shadow1" v-for="(item,index) in items" :key="index+'_item'">
      <!-- 左侧 -->
      <el-col :span="8">
        <el-row class="store_left topandb2">
          <el-col :span="18" class="xy_flex">
            <div class="store_left_img xy_radius4 pointerHover"  @click="$router.push(`/shopStore_supplier?storeId=${item.bxmId}`)" style="cursor:pointer">
              <el-image
                :src="`${item.logo}`"
                fit="fill"
                class="img_shadow2"
                style="width: 62px; height: 62px"
              >
                <div slot="error" class="image-slot">
                  <i class="el-icon-picture-outline"></i>
                </div>
              </el-image>
            </div>
            <div>
              <el-col :span="24"
                ><div @click="$router.push(`/shopStore_supplier?storeId=${item.bxmId}`)" style="cursor:pointer;font-size: 16px;margin-bottom: 4px;" class="grid-content bg-purple-dark xy_line_height2 pointerHover">
                  {{item.name}}
                </div></el-col
              >
              <el-col :span="24"
                ><div class="store_top xy_line_height2">
                  <span class="font-color">所在地：</span>{{item.address}}
                </div></el-col
              >
              <el-col :span="24"
                ><div class="store_top xy_line_height2 font-color">
                  主营商品：
                </div></el-col
              >
              <el-col :span="24"
                ><div class="store_top xy_line_height2">{{item.sortname}}</div></el-col
              >
            </div>
          </el-col>
          <el-col :span="6">
            <!-- <el-button @click="addCollectionHandle(item.bxmId)" v-if="item.isCollect==0?true:false" size="mini" icon="el-icon-star-off">关注店铺</el-button>
            <el-button @click="removeCollectionHandle(item.bxmId)" v-if="item.isCollect==1?true:false" size="mini" icon="el-icon-star-on">已关注</el-button> -->
          </el-col>
        </el-row>
      </el-col>
      <!-- 右侧 -->
      <el-col :span="16">
        <div class="grid-content bg-purple-light">
          <el-row class="store_left store_right_box">
            <el-col :span="6" v-for="(goodsitem,index) in item.goods" :key="'goods_'+index">
            <el-col :span="24" class="store_layout_center">
              <div class="grid-content bg-purple-dark">
                  <el-image
                  :src="`${goodsitem.photos}`"
                  fit="fill"
                  class="img_shadow2"
                  style="width: 150px; height: 150px"
                >
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
              </div>
            </el-col>
            <el-col :span="24" class="xy_l_r5">
              <router-link
                    :to="`/goodsDetail_supplie?id=${goodsitem.id}`"
                    class="item_link"
                  >
              <el-link class="xy_hidden_line1"  :underline="false" :title="goodsitem.name">{{goodsitem.name}}</el-link></router-link>
            </el-col>
            <el-col :span="24" class="xy_l_r5">
              <el-row type="flex" justify="space-between">
                <el-col :span="12">
                  <span class="font_pirce_color" v-if="!item.isNotSupplie">--</span>
                  <span class="font_pirce_color" v-else>￥{{goodsitem.realprice||0}}</span>
                </el-col>
                <el-col :span="12" class="xy_layout_right"><span class="font-color xy_layout_right xy_line_height2">售出{{goodsitem.saleNum||0}}件</span></el-col>
              </el-row>
            </el-col>
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 导入组件
// REQ
import { merchantlistSupplie,addCollection,removeCollection } from "@/api/xunyou";
// import headerComponent from "./head.vue";
// 导出模块
export default {
  // 模块名字
  name: "template",
  // 模块数据
  data() {
    //数据
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      items: [], 
    };
  },
  // 注册组件
  components: {
    // headerComponent,
  },
  // 监听指定值，只有指定值变化，才会触发
  watch: {},
  // 创建前状态(里面是操作)
  beforeCreate() {},
  // 创建完毕状态(里面是操作)
  created() {
    this.searchStorerList();
  },
  // 挂载前状态(里面是操作)
  beforeMount() {},
  // 挂载结束状态(里面是操作)
  mounted() {},
  // 更新前状态(里面是操作)
  beforeUpdate() {},
  // 更新完成状态(里面是操作)
  updated() {},
  // 销毁前状态(里面是操作)
  beforeDestroy() {},
  // 销毁完成状态(里面是操作)
  destroyed() {},
  // 里面的函数只有调用才会执行（实时计算）里面是定义的方法
  methods: {
    // 店铺查询
    searchStorerList() {
      this.loading = true;
      merchantlistSupplie({type: 1,userId:this.userInfo.userId||''})
        .then((res) => {
            this.loading = false;
            this.items = res.rows;          
          
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("店铺查询失败，请稍后再试！");
        });
    },
      // 添加关注
    addCollectionHandle(id) {
      if(this.userInfo.userId==undefined){
            this.$message.error("请登录！");
            setTimeout(()=>{
              this.$router.push('/login')
            },2000)
            return
          }
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      addCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
    // 取消关注
    removeCollectionHandle(id) {
      // this.loading = true;
      const req ={
        type:2, //1:商品；2：店铺；必填
        uid:this.userInfo.userId,
        cid:id, // 店铺id
      }
      removeCollection(req)
        .then((res) => {
          if(res.code == 0){
            this.searchStorerList()
          }
        })
        .catch((err) => {
          this.$message.error("关注失败，请稍后再试！");
        });
    },
  },
};
</script>
// scoped 样式只在本组件使用
<style scoped lang='less'>
/**
 * 导入css样式组件
 * @import "../assets/css/components/index.css";
 */

 .xy_layout_right{
   text-align: right;
 }
 .pointerHover:hover{
   color: #78b942;
 }
.store_bg {
  background: url("../../assets/images/summary_bg.jpg") 0 100% no-repeat #f8f8f8;
  background-size: cover;
  /* margin-bottom: 15px; */
}
.store_min_h {
  min-height: 223px;
}
.store_left {
  text-align: left;
  /deep/i.el-icon-star-on {
    font-size: 18px;
    color: #78b942;
    vertical-align: text-bottom;
  }
  /deep/i.el-icon-star-off{
    font-size: 18px;
    vertical-align: text-bottom;
  }
}
.store_layout_center{
  text-align: center;
}
.store_left_img {
  margin: 0 20px;
}
.store_top {
  margin-top: 3px;
}
.font-color {
  color: #999;
}
.store_right_box {
  /* margin: 0 20px; */
  padding: 15px 15px 5px;
}
.font_pirce_color{
    display: inline-block;
    color: #78b942;
    overflow: hidden;
    font-size: 14px;
    font-weight: 700;
    font-style: normal;
}
</style>



// WEBPACK FOOTER //
// src/views_supplier/store/store.vue